export default __webpack_public_path__ + "static/media/tailwind.9c2e5bcf.png";